/**
 * SelectViewButtonContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled select view button container.
 */
const SelectViewButtonContainer = styled.div``;

export default withOpacity(SelectViewButtonContainer);
